import { defaultHttpClient } from '../../httpClient';
import type { GoodsDiscountsResponse } from './types';

export const getGoodsDiscounts = (
  goodsId: number,
  fixedCouponSno?: number,
) => {
  return defaultHttpClient
    .request<GoodsDiscountsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsId}/discounts/`,
      params: { fixed_coupon_sno: fixedCouponSno },
    })
    .then(result => result.data);
};
